/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { tryDefine } from '@tylertech/forge-core';
import { METER_GROUP_TAG_NAME, MeterGroupComponent } from './meter-group';
export * from './meter-group';
export function defineMeterGroupComponent() {
    tryDefine(METER_GROUP_TAG_NAME, MeterGroupComponent);
}
